import axios from 'axios';

class ApiService {
  constructor() {
    // URL correcta del backend usando HTTPS
    this.baseURL = process.env.REACT_APP_API_URL || 'https://nubemotic.cloud';
    this.client = axios.create({
      baseURL: this.baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    this.client.interceptors.request.use(
      (config) => {
        console.log('🌍 API Request:', {
          method: config.method?.toUpperCase(),
          url: config.baseURL + config.url,
          headers: config.headers,
          data: config.data
        });

        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = 'Bearer ' + token;
        }
        return config;
      },
      (error) => {
        console.error('❌ API Request Error:', error);
        return Promise.reject(error);
      }
    );

    this.client.interceptors.response.use(
      (response) => {
        console.log('✅ API Response:', {
          status: response.status,
          url: response.config.url,
          data: response.data
        });
        return response;
      },
      (error) => {
        console.error('❌ API Response Error:', {
          status: error.response?.status,
          url: error.config?.url,
          message: error.message,
          data: error.response?.data
        });

        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  setAuthToken(token) {
    if (token) {
      this.client.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  async login(credentials) {
    return this.client.post('/api/auth/login', credentials);
  }

  async verify() {
    return this.client.get('/api/auth/verify');
  }

  async get(url, params = {}) {
    return this.client.get(url, { params });
  }

  async post(url, data) {
    return this.client.post(url, data);
  }

  async put(url, data) {
    return this.client.put(url, data);
  }

  async delete(url) {
    return this.client.delete(url);
  }

  // Enviar comando a dispositivo
  async sendCommand(deviceId, commandId) {
    return this.client.post(`/api/devices/${deviceId}/command`, { commandId });
  }

  // Obtener logs de comandos de un dispositivo
  async getCommandLogs(deviceId, params = {}) {
    return this.client.get(`/api/devices/${deviceId}/command-logs`, { params });
  }
}

export default new ApiService();